import React from 'react';

interface LanguageToggleProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  globeSrc: string;
  fullLabel: string;
  shortLabel?: string;
  globeClassName?: string;
  fullLabelClassName?: string;
  shortLabelClassName?: string;
  chevronClassName?: string;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({
  globeSrc,
  fullLabel,
  shortLabel = 'EN',
  globeClassName,
  fullLabelClassName,
  shortLabelClassName,
  chevronClassName,
  type = 'button',
  ...props
}) => {
  return (
    <button type={type} {...props}>
      <img src={globeSrc} alt="" className={globeClassName} aria-hidden="true" />
      <span className={fullLabelClassName}>{fullLabel}</span>
      <span className={shortLabelClassName}>{shortLabel}</span>
      <svg className={chevronClassName} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

export default LanguageToggle;
